import { render, staticRenderFns } from "./GamesListLayout.vue?vue&type=template&id=98c85ed2&"
import script from "./GamesListLayout.vue?vue&type=script&lang=js&"
export * from "./GamesListLayout.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports